import * as repo from "../repositories/compensationRepository.js";
import { logError } from "../../../shared/utils/logger.js";

export const getCompensationPlansByJobId = async (jobId) => {
  try {
    const res = await repo.fetchCompensationPlansByJobId(jobId);
    if (!res.success) throw new Error(res.error || "Failed to load compensation plans");
    return { success: true, data: res.data };
  } catch (error) {
    logError("getCompensationPlansByJobId", { jobId, error: error.message });
    return { success: false, error: error.message, data: [] };
  }
};

export const createCompensationPlan = async (jobId, data) => {
  try {
    const res = await repo.createCompensationPlan(jobId, data);
    if (!res.success) throw new Error(res.error || "Failed to create compensation plan");
    return { success: true, data: res.data };
  } catch (error) {
    logError("createCompensationPlan", { jobId, error: error.message });
    return { success: false, error: error.message };
  }
};

export const previewCompensationInstallmentEmail = async (
  jobId,
  planId,
  sequence,
  params = {}
) => {
  try {
    const res = await repo.previewInstallmentEmail(jobId, planId, sequence, params);
    if (!res.success) throw new Error(res.error || "Failed to load email preview");
    return { success: true, data: res.data };
  } catch (error) {
    logError("previewCompensationInstallmentEmail", {
      jobId,
      planId,
      sequence,
      error: error.message,
    });
    return {
      success: false,
      error: error.response?.data?.error || error.message,
    };
  }
};

export const previewCompensationProviderFyiEmail = async (
  jobId,
  planId,
  sequence,
  params = {}
) => {
  try {
    const res = await repo.previewProviderFyiEmail(jobId, planId, sequence, params);
    if (!res.success) throw new Error(res.error || "Failed to load provider FYI preview");
    return { success: true, data: res.data, skip: res.data?.skip };
  } catch (error) {
    logError("previewCompensationProviderFyiEmail", {
      jobId,
      planId,
      sequence,
      error: error.message,
    });
    return { success: false, error: error.message };
  }
};

export const payCompensationInstallment = async (jobId, planId, sequence, formData) => {
  try {
    const res = await repo.payInstallment(jobId, planId, sequence, formData);
    if (!res.success) throw new Error(res.error || "Failed to pay installment");
    return { success: true, data: res.data, message: res.message };
  } catch (error) {
    const errBody = error?.data || error?.response?.data;
    logError("payCompensationInstallment", { jobId, planId, sequence, error: error.message });
    return {
      success: false,
      error: errBody?.error || error.message,
      data: errBody?.data,
    };
  }
};

export const getDueInstallments = async (asOf) => {
  try {
    const res = await repo.fetchDueInstallments(asOf);
    if (!res.success) throw new Error(res.error || "Failed to load due installments");
    return { success: true, data: res.data };
  } catch (error) {
    logError("getDueInstallments", { error: error.message });
    return { success: false, error: error.message, data: [] };
  }
};
